import { takeEvery, call, put, select } from 'redux-saga/effects';
import {
  requestInProcess,
  requestFinished,
  sendRequest,
  selectServiceArgs
} from '../../../../common/reducers/userNoticesSetReadForm';

import {
  updateList,
  sendRequest as sendRequestList,
  selectItemsIds,
  selectPagination
} from '../../../../../../common/reducers/list/reducer';

import {
  selectItemById,
  insertUpdateItems
} from '../../../../../../common/reducers/objectCollection/reducer';

import { timeoutCall } from '../../../../../../utils/sagaHalper';
import EventsUserNoticeService from '../../../../services/EventsUserNoticeService';

// Изменение кол-ва не прочитанных уведомлений. и пометка уведомления как прочитанного
function* correctEventsNotReadUserNoticesList(noticeId) {
  const listRN = 'eventsModule.lists.eventsNotReadUserNoticesList';
  const paginationN = yield select(selectPagination, listRN);
  let itemsIdsN = yield select(selectItemsIds, listRN);
  if (noticeId === 'all') {
    paginationN.totalCount = 0;
    itemsIdsN = [];
    yield put(sendRequestList('eventsModule.lists.eventsUserNoticesList'));
  } else {
    paginationN.totalCount -= 1;
  }
  yield put(
    updateList(listRN, {
      itemsIds: itemsIdsN,
      pagination: paginationN
    })
  );

  const collRN = 'eventsModule.collections.eventsUserNoticesCollection';
  const itemById = yield select(selectItemById, collRN, noticeId);
  itemById.noticeAppStatus = 2;
  yield put(
    insertUpdateItems(collRN, {
      [noticeId]: itemById
    })
  );
}

function* userNoticesSetReadFormSaga(reducerName) {
  yield put(requestInProcess(reducerName));
  const serviceArgs = yield select(selectServiceArgs, reducerName);
  try {
    const result = yield call(
      timeoutCall,
      EventsUserNoticeService.setRead,
      serviceArgs[0]
    );
    if (result.status === 200) {
      yield correctEventsNotReadUserNoticesList(serviceArgs[0]);
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
}

export default function getSaga(reducerName) {
  return [
    takeEvery(
      sendRequest(reducerName).type,
      userNoticesSetReadFormSaga,
      reducerName
    )
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/events/reducers/static/forms/sagas/userNoticesSetReadFormSaga.js